import {isOnLine} from './constantconfig'

export default {
  /**
   * api请求基础路径
   */
  baseUrl: {
    dev: 'https://apis.cfc99.com', // 测试 https://api.fat.laodao.co  https://apis.cfc99.com
    pro: 'https://apis.cfc99.com', // 线上
    debug: 'https://api.fat.laodao.co'
  },
  cookieExpires: 10,

  // 上传图片测试、线上
  region: isOnLine ? 'oss-cn-shanghai' : 'oss-cn-qingdao',
  accessKeyId: isOnLine ? 'LTAIufO1A3SGZZ5t' : 'LTAIduij3bFJxU5P',
  accessKeySecret: isOnLine ? 'sD83aWrXq89HmNgwpCbrGhDWKGDsia' : 'Onih3CvVSCUVsEagRpHJjtpqI7VcxA',
  bucket: isOnLine ? 'service-center-image' : 'service-center',

  /**
   * 视频线下
   */
  dev_video_region: 'oss-cn-qingdao',
  dev_video_accessKeyId: 'LTAIs3oSm15PNQLQ',
  dev_video_accessKeySecret: 'CqooofLcKftoaqN5wrgYxOru1DB7nE',
  dev_video_bucket: 'service-center-video-test',
  dev_url: 'http://video.test.laodao.co/',
  /**
   * 视频线上
   */
  pro_video_region: 'oss-cn-shanghai',
  pro_video_accessKeyId: 'LTAIufO1A3SGZZ5t',
  pro_video_accessKeySecret: 'sD83aWrXq89HmNgwpCbrGhDWKGDsia',
  pro_video_bucket: 'service-center-video',
  pro_url: 'http://video.laodao.so/',

  homeName: 'HomePageList'
}
